// extracted by mini-css-extract-plugin
export default {"main":"Card_main__-BCKi","iconSVG":"Card_iconSVG__5LCuY"};